import { useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "../_shared";
import { useApi, act, Pill, Panel, Btn, Field, inputCls, JsonEditor, Table, Stat, fmtTs } from "./_kit";

export default function EventBus() {
  const [filter, setFilter] = useState("");
  const { data: stats, reload: r1 } = useApi("/events/stats");
  const { data: types } = useApi("/events/types");
  const { data: evs, reload: r2 } = useApi(`/events?limit=100${filter ? `&event_type=${filter}` : ""}`, [filter]);
  const [type, setType] = useState("TransactionCreated");
  const [mobile, setMobile] = useState("");
  const [payload, setPayload] = useState({ bill_amount: 6500, bill_number: "BB-TEST-1" });
  const reload = () => { r1(); r2(); };
  return (
    <div>
      <PageHeader subtitle="Canonical event model · async bus" title="Event Bus" actions={<Btn variant="ghost" data-testid="events-refresh" onClick={reload}>Refresh</Btn>} />
      <div className="p-6 space-y-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <Stat label="Events (24h)" value={stats?.last_24h} testid="events-24h" />
          <Stat label="Unprocessed" value={stats?.unprocessed} testid="events-unprocessed" />
          <Stat label="Event types seen" value={stats?.by_type?.length} />
          <Stat label="Catalogue" value={types?.types?.length} hint="canonical types" />
        </div>
        <div className="grid grid-cols-12 gap-4">
          <Panel className="col-span-12 lg:col-span-4" title="Emit test event" eyebrow="Manual publish" testid="events-emit-panel">
            <div className="space-y-3">
              <Field label="Event type">
                <select data-testid="events-emit-type" className={inputCls} value={type} onChange={(e) => setType(e.target.value)}>
                  {(types?.types || []).map((t) => <option key={t}>{t}</option>)}
                </select>
              </Field>
              <Field label="Customer mobile"><input data-testid="events-emit-mobile" className={inputCls} value={mobile} onChange={(e) => setMobile(e.target.value)} /></Field>
              <Field label="Payload"><JsonEditor value={payload} onChange={setPayload} rows={6} testid="events-emit-payload" /></Field>
              <Btn data-testid="events-emit-btn" onClick={async () => { await act(api.post("/events/emit", { event_type: type, payload, customer_mobile: mobile || null }), "Event published"); setTimeout(reload, 600); }}>Publish</Btn>
            </div>
            <div className="mt-5">
              <div className="text-[10px] uppercase tracking-[0.2em] text-neutral-500 mb-2">By type</div>
              <div className="flex flex-wrap gap-1.5">
                <button className={`px-2 py-0.5 text-[11px] rounded-sm border ${!filter ? "bg-[#141414] text-white" : "border-black/15"}`} onClick={() => setFilter("")}>all</button>
                {(stats?.by_type || []).map((b) => (
                  <button key={b.event_type} data-testid={`events-type-${b.event_type}`} onClick={() => setFilter(b.event_type)}
                    className={`px-2 py-0.5 text-[11px] rounded-sm border ${filter === b.event_type ? "bg-[#5A1A22] text-white" : "border-black/15 hover:bg-neutral-100"}`}>{b.event_type} · {b.count}</button>
                ))}
              </div>
            </div>
          </Panel>
          <Panel className="col-span-12 lg:col-span-8" title="Recent events" eyebrow={filter || "All types"} testid="events-table-panel">
            <Table testid="events-table" rows={evs?.items} cols={[
              { key: "created_at", label: "When", render: (r) => fmtTs(r.created_at) },
              { key: "event_type", label: "Type", render: (r) => <span className="font-semibold">{r.event_type}</span> },
              { key: "customer_mobile", label: "Mobile" }, { key: "source", label: "Source" },
              { key: "processed", label: "Handlers", render: (r) => <Pill value={r.processed ? (r.handler_results?.every((h) => h.ok) ? "success" : "failed") : "pending"} /> },
              { key: "payload", label: "Payload", render: (r) => <code className="text-[10px] text-neutral-600 break-all">{JSON.stringify(r.payload).slice(0, 140)}</code> },
            ]} />
          </Panel>
        </div>
      </div>
    </div>
  );
}
